<!-- https://www.figma.com/file/reAk2sU4YpRajpQu2YBOHk/007%2F1.-%D0%AD%D0%BB%D0%B5%D0%BC%D0%B5%D0%BD%D1%82%D1%8B?type=design&node-id=3-1&mode=design&t=Sz5lS3pfHvZfwJyY-0 -->
<template>
  <div class="pull-quote">
    <TheContent
      v-for="item of elem.children"
      :key="item.id"
      :elem="item"
    />
  </div>
</template>

<script lang="ts">
  import type { PropType } from 'vue';
  import TheContent from '~/components/content/TheContent';

  export default defineNuxtComponent({
    name: 'PullQuote',
    components: {
      TheContent,
    },

    props: {
      elem: {
        type: Object as PropType<TContent>,
        required: true,
      },
    },
  });
</script>

<style lang="scss" scoped>
  .pull-quote {
    @include extraBigTextMobile;
    font-family: $secondFont;
    color: black;
    font-weight: 600;

    margin: 32px 0px;
    padding: 16px 0px;

    width: 100%;

    border-top: 3px solid var(--main-color);
    border-bottom: 3px solid var(--main-color);

    @include tablet {
      @include bigText;
    }

    :deep() {
      cite {
        font-style: normal;
      }
    }

    :deep() {
      figure {
        margin: 16px 0px;
      }
    }

    :deep() {
      blockquote {
        &::before {
          display: none;
        }

        & p {
          margin: 0;
        }

        padding: 0;
        margin: 0;
        border: none;
      }
    }

    :deep() {
      a {
        @include linkStyle;
      }
    }
  }
</style>
